import React, { useState } from 'react'
import { IoMdClose } from "react-icons/io";
import { withTranslation } from "react-i18next";

const QuickBuyInformationPopup = (props) => {
	const { onClose } = props;
	const [activeTab, setActiveTab] = useState(0); // State to track active tab

	const Content1 = () => {
		return <>
			<h3>Contoh 1:</h3>
			<p>Beli angka 4521 sebesar IDR 10.000, angka 421 sebesar IDR 10.000, angka 33 sebesar IDR 7.000, 4523 sebesar IDR 6.000</p>
			<p><strong>Maka formatnya :</strong></p>
			<p>4521.421=10,33=7,4523=6</p>
			<p>4521.421:10,33:7,4523:6</p>
			<p>4521*421#10+33#7+4523#6</p>
			<p>4521.421.@10rb.33.@7rb.4523.@6rb.</p>
			<br></br>
			<p>* Jika beli angka 45212 BB Campuran 4d = IDR 1.000, 3d = IDR 2.000, 2d = IDR 5.000 dan 5521 (1 set 4d,3d,2d) sebesar IDR 5.000. Maka formatnya :</p>
			<br></br>
			<p>45212 bb 1/2/5, 5521=5/5/5</p>
		</>
	}
	const Content2 = () => {
		return <>
			<h3>Contoh 1:</h3>
			<p>Beli colok bebas angka 1,2 sebesar IDR 10.000 dan angka 3 sebesar IDR 20.000. Maka formatnya :</p>
			<p><strong>Maka formatnya :</strong></p>
			<p>cb1.2=10. 3=20</p>
			<p>cb1.2x10. 3x20</p>
			<p>colok 1.2=10. 3=20</p>
			<p>colok 1.2x10. 3x20</p>
			<p>Cb 1*2#10+3#20</p>
			<p>cb1.2:10. 3:20</p>
			<p>Colok 1,2.@10rb.3.@20rb</p>
			<br></br>
			<h3>Contoh 2:</h3>
			<p>Beli colok bebas 2d angka 1&2 dan 3&4 sebesar IDR 10.000 dan angka 3&4 sebesar IDR 20.000. Maka formatnya :</p>

			<p>colok macau 12.34=10. 34=20</p>
			<p>cm12.34=10. 34=20</p>
			<p>cp12.34x10. 34=20</p>
			<p>cm 12*34#10+34#20</p>
			<p>cm12.34:10. 34:20</p>
			<p>Mako 1/2,,34,,@10rb..34@20rb</p>
			<br></br>
			<h3>OM</h3>
			<p>1+2=10</p>
			<p>3+4=10</p>
			<p>3+4=20</p>
			<br></br>

			<h3>Contoh 3:</h3>
			<p>Beli colok naga angka 1,2,3 dan 3,4,5 sebesar IDR 10.000 dan angka 1,5,8 sebesar IDR 20.000. Maka formatnya :</p>

			<p>coloknaga 123.345=10. 158=20</p>
			<p>coloknaga 123.345x10. 158x20</p>
			<p>cn 123.345=10. 158=20</p>
			<p>cn 123.345x10. 158x20</p>
			<p>cn 123.345:10. 158:20</p>
			<br></br>
			<h3>LM</h3>
			<p>3+0+4=20</p>
			<p>2+0+4=40</p>
			<p>2+5+4=10</p>
			<br></br>
			<h3>Contoh 4:</h3>
			<p>ilustrasi</p>
			<p>ABCD → A=As, B=Kop, C=Kepala, D=Ekor</p>
			<br></br>
			<p>Beli colok jitu As 9 sebesar IDR 10.000, colok jitu Kop 8 sebesar IDR 10.000, colok jitu Kepala 3 sebesar IDR 20.000, colok jitu Ekor 5 sebesar IDR 15.000. Maka formatnya :</p>
			<br></br>
			<p>cjA 9=10, cjK 8=10, cjKp 3=20, cjE 5=15</p>
			<p>cjA 9:10, cjK 8:10, cjKp 3=20, cjE 5=15</p>
			<p>cjA 9x10, cjK 8x10, cjKp 3x20, cjE 5x15</p>
			<p>cjA 9#10, cjK 8#10, cjKp 3#20, cjE 5#15</p>
			<br></br>
			<p>Jitu as 9=10rb.</p>
			<p>Jitu kop 8=10rb.</p>
			<p>Jitu kepala 3=20rb.</p>
			<p>Jitu ekor 5=15rb.</p>

		</>
	}
	const Content3 = () => {
		return <>
			<h3>Contoh 1:</h3>
			<p>Beli tengah sebesar IDR 10.000, Tepi sebesar IDR 25.000. Maka formatnya :</p>
			<br></br>
			<p>tengah=10, tepi=25</p>
			<p>tengahx10, tepix25</p>
			<p>tengah:10, tepi:25</p>
			<p>tengah#10, tepi#25</p>
			<br></br>
			<h3>Contoh 2:</h3>
			<p>ilustrasi</p>
			<p>ABCD →A=As, B=Kop, C=Kepala, D=Ekor</p>
			<br></br>
			<p>Beli posisi As Genap sebesar IDR 10.000, Posisi Kop Ganjil sebesar IDR 15.000, Posisi Kepala Besar sebesar IDR 25.000, Posisi Ekor Kecil sebesar IDR 20.000. Maka formatnya :</p>
			<br></br>
			<p>ASgenap=10, kopganjil=15, KepalaBesar=25, EkorKecil=20</p>
			<p>ASgenapx10, kopganjilx15, KepalaBesarx25, EkorKecilx20</p>
			<p>ASgenap#10, kopganjil#15, KepalaBesar#25, EkorKecil#20</p>
			<p>ASgenap:10, kopganjil:15, KepalaBesar:25, EkorKecil:20</p>
			<p>ribuan genap 10rb. ratusan ganjil 15rb. puluhan besar 25rb. Ekor kecil 20rb.</p>
			<br></br>
			<h3>Contoh 3:</h3>
			<p>Beli Genap sebesar IDR 10.000, Besar sebesar IDR 20.000. Maka formatnya :</p>
			<br></br>
			<p>genap=10, besar=20</p>
			<p>genapx10, besarx20</p>
			<p>genap#10, besar#20</p>
			<p>genap:10, besar:20</p>
			<br></br>
			<h3>Contoh 4:</h3>
			<p>Beli Shio Babi sebesar IDR 10.000, Kelinci sebesar IDR 20.000. Maka formatnya :</p>
			<br></br>
			<p>shio 1=10, shio 9=20</p>
			<p>shio 1x10, shio 9x20</p>
			<p>shio 1#10, shio 9#20</p>
			<p>shio 1:10, shio 9:20</p>
			<p>Sio. 1x10. 9x20</p>
			<p>Sio. 1=10. 9=20</p>
			<p>Sio. 1#10. 9#20</p>
			<p>Sio. 1:10. 9:20</p>
			<p>babi#10+kelinci#20</p>
			<p>babi=10,kelinci=20</p>
			<p>babix10,kelincix20</p>
			<br></br>
			<h3>Contoh 5: </h3>
			<p>Susunan Format untuk kombinasi :</p>
			<p>(untuk bagian kepala)+(untuk bagian ekor)=Nilai Taruhan</p>
			<br></br>
			<p><strong>Format untuk kombinasi :</strong></p>
			<p>ganjil+ganjil=1</p>
			<p>ganjil+genap=1</p>
			<p>ganjil+besar=1</p>
			<p>ganjil+kecil=1</p>
			<br></br>
			<p>genap+ganjil=1</p>
			<p>genap+genap=1</p>
			<p>genap+besar=1</p>
			<p>genap+kecil=1</p>
			<br></br>
			<p>besar+ganjil=1</p>
			<p>besar+genap=1</p>
			<p>besar+besar=1</p>
			<p>besar+kecil=1</p>
			<br></br>
			<p>kecil+ganjil=1</p>
			<p>kecil+genap=1</p>
			<p>kecil+besar=1</p>
			<p>kecil+kecil=1</p>
			<br></br>
			<h3>Contoh 6:</h3>
			<p>Beli angka 4521,321,21 sebesar Rp 100.000, angka 1317 sebesar Rp 150.000, angka 2174 sebesar Rp 150.000, angka 217 sebesar Rp 5.000, angka 12 = Rp 100.000, colok bebas 1 sebesar Rp 33.500.000, Tengah sebesar Rp 10.000. Maka formatnya :</p>
			<br></br>
			<p>4521.321.21=100</p>
			<p>1317=150,2174=150</p>
			<p>217=5,12=100</p>
			<p>cb1=33500</p>
			<p>Tengah=10</p>
		</>
	}
	// Tab data
	const tabs = [
		{ label: "Angka", content: <Content1 /> },
		{ label: "Colok", content: <Content2 /> },
		{ label: "Samping", content: <Content3 /> }
	];
	return (
		<div className="overlay">
			<div className="informasi_popup">
				<button className="informasi_popup-close" onClick={onClose}>
					<IoMdClose className="btnclose" />
				</button>
				<div className="result_txt">{props.t('information')}</div>
				<div className='information_content'>
					<div>
						{/* Tab Buttons */}
						<div className="tabs quick_info_tabs">
							{tabs.map((tab, index) => (
								<button
									key={index}
									className={activeTab === index ? "active" : ""}
									onClick={() => setActiveTab(index)}
								>
									{tab.label}
								</button>
							))}
						</div>
						{/* Tab Content */}
						<div className="tab-content quickbuy_tab-content">
							{tabs[activeTab].content}
						</div>

					</div>



				</div>
			</div>
		</div>
	)
}

export default withTranslation()(QuickBuyInformationPopup)